import { localDateKey } from "./audio-media-utils.mjs";

export function sanitizeDownloadName(value) {
  const stem = String(value || "todays-brief-audio")
    .trim()
    .toLowerCase()
    .replace(/\.mp3$/i, "")
    .replace(/['"]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
  return `${stem || "todays-brief-audio"}.mp3`;
}

export function defaultDownloadName(key, label) {
  return sanitizeDownloadName(`${key.split(":")[0] || "audio"}-${label}-${localDateKey()}`);
}
